var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideobg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 726.09,
    height: 464.32,
    viewBox: "0 0 726.09 464.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;mix-blend-mode:screen;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.25,30.69A29.69,29.69,0,0,1,49.94,1H695.4a29.69,29.69,0,0,1,29.69,29.69V433.63a29.69,29.69,0,0,1-29.69,29.69H49.94a29.69,29.69,0,0,1-29.69-29.69V179.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.82,150.47.42,156v-5.13l16-2.31,11.27-1.43V147l-11.27-1.22-16-1.93v-5l35.4,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.82,132H.42v-5.39h35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.82,117.85H.42v-7.94a7.68,7.68,0,0,1,1.08-4.32,6,6,0,0,1,3.11-2.37,14.45,14.45,0,0,1,4.9-.73l16,0a19,19,0,0,1,5.79.75,6.41,6.41,0,0,1,3.43,2.43,7.81,7.81,0,0,1,1.12,4.44Zm-4.18-5.38v-1.78a3,3,0,0,0-.38-1.57,2.33,2.33,0,0,0-1.36-1,9.46,9.46,0,0,0-2.77-.31l-17.48,0a8.48,8.48,0,0,0-3.9.66,2.45,2.45,0,0,0-1.18,2.34v1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.82,94.29H.42V82.42H5.07V88.9h10.3V82.74h4.54V88.9H31.17V82.18h4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.22,67.46A8,8,0,0,1,35.06,72a6.77,6.77,0,0,1-3.46,2.57,16.91,16.91,0,0,1-5.67.82H9.73a15.3,15.3,0,0,1-5.23-.8A6.64,6.64,0,0,1,1.17,72,8.08,8.08,0,0,1,0,67.4a8.77,8.77,0,0,1,.66-3.6,6,6,0,0,1,1.92-2.38,8.37,8.37,0,0,1,3.06-1.31,18.11,18.11,0,0,1,4.09-.42h16.2a17.47,17.47,0,0,1,5.67.8A6.67,6.67,0,0,1,35.06,63,7.84,7.84,0,0,1,36.22,67.46Zm-4.66,0A1.83,1.83,0,0,0,31,66a3.62,3.62,0,0,0-1.84-.68A24.09,24.09,0,0,0,26,65.1H9.49a11.4,11.4,0,0,0-3.57.44A1.76,1.76,0,0,0,4.67,67.4a2,2,0,0,0,1.21,2,9.48,9.48,0,0,0,3.59.52H26a24.55,24.55,0,0,0,3.16-.17A3.34,3.34,0,0,0,31,69,2.05,2.05,0,0,0,31.56,67.46Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideobg2);
export default __webpack_public_path__ + "static/media/videobg2.b13bb501ec6306877713de128219f15e.svg";
export { ForwardRef as ReactComponent };